'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

function parseResultsMobile(response) {
    var $results = $(response);

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
            $('body').css('overflow-y','hidden');
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.validate, .modal-background,.refinement-bar button.close-refinement-popin', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
            $('body').css('overflow-y','auto');
        });
    },
    order: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.order-results', function () {
            $('.refinement-bar-order, .modal-background').show();
            $('.refinement-bar-order').siblings().attr('aria-hidden', true);
            $('.refinement-bar-order').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar-order').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar-order').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar-order .close').focus();
        });
    },

    closeorder: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar-order button.validate, .modal-background,.refinement-bar-order button.btn-close-trie', function () {
            $('.refinement-bar-order, .modal-background').hide();
            $('.refinement-bar-order').siblings().attr('aria-hidden', false);
            $('.refinement-bar-order').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar-order').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar-order').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
        $('.container').on('click', '.refinement-bar-order .close-refinement', function (e) {
            e.preventDefault();
            var parentRefinement = $(this).parents('.refinement-bar-order');
            parentRefinement.find('.refinements-order .check-square').removeClass('checked');
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('click', '.refinements-order:not(.refinements-order-mobile) .values button', function (e) {
            e.preventDefault();
            $.spinner().start();
            var $clickedButton = $(this);
            var url = $(this).data('href');
            $(this).trigger('search:sort', url);
        
            $.ajax({
                url: url,
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);

                    var selectedText = $clickedButton.find('span[aria-hidden="true"]').text().trim();
                    $('.refinement-trie .accordion-title h3 .title-trie-text').text(selectedText);
                    $('.filter-trie-block .order-selected').empty().text(selectedText);
                    applyScrolling();
                    paginationPlp();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        
            $(this).closest('.values').find('button').each(function () {
                $(this).find('.check-square').removeClass('checked');
                $(this).find('span').removeClass('selected');
            });
            $(this).find('.check-square').addClass('checked');
            $(this).find('span').addClass('selected');
        });
    },
    sortMobile: function () {
        // Handle sort order menu selection
        $('.container').on('click', '.refinements-order.refinements-order-mobile .values button', function (e) {
            $(this).closest('.values').find('button').each(function () {
                $(this).find('.check-square').removeClass('checked');
                $(this).find('span').removeClass('selected');
            });
            $(this).find('.check-square').addClass('checked');
            $(this).find('span').addClass('selected');
        });

        $('.container').on('click','.refinement-bar-order .filter-footer .btn-primary', function () {
            var $selectedOption = $('.refinements-order-mobile .values button .check-square.checked');
            var $selectedButton = $selectedOption.parents('button');

            if ($selectedButton.length > 0) {
                var url = $selectedButton.data('href');
                $.spinner().start();
        
                $.ajax({
                    url: url,
                    method: 'GET',
                    success: function (response) {
                        $('.product-grid').empty().html(response);
                        var selectedText = $selectedButton.find('span[aria-hidden="true"]').text().trim();
                        $('.refinement-trie .accordion-title h3 .title-trie-text').text(selectedText);
                        $('.filter-trie-block .order-selected').empty().text(selectedText);
                        
                        applyScrolling();
                        fixedRefinementBarMobile();
                        paginationPlp();
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            var pageNumber = $('#next-page-href').data('page-number');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { 
                    selectedUrl: showMoreUrl,
                    pageNumber: pageNumber
                },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                    var tecCountProduct = $('.tec-product-tile').length;
                    $(".tec-number-product .tec-load-more-p").text(function (i, txt) {
                        return txt.replace(/\d+/, tecCountProduct);
                    });
                    applyScrolling();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    generatePrevisousPlpLink: function() {
        $(document).on('click', '.tec-remember', function(event) {
            // Check if the clicked element is the parent or a child (the button)
            if (!$(event.target).is('.quickview') || !$(event.target).closest('.quickview').length > 0) {
                const pid = $(this).data('pid');
                var filterUrl = $('.grid-footer .permalink').val();
                var scrollPosition = $(document).scrollTop();
                sessionStorage.setItem('scrollPosition_PLP', scrollPosition.toString());
                window.history.replaceState(null, "", decodeURI(filterUrl));
            }
        });
    },
    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.filtre-desktop .refinements li button,.refinement-bar button.reset,.filtre-desktop .filter-value button,.filtre-desktop .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $target = $(e.target);

                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        paginationPlp();
                        $.spinner().stop();
                        $(".filtres .accordion-title").click(function(e) {
                            var accordionItem = $(this).attr("data-tab");
                            $(this).toggleClass("tec-arrow");
                            $(this).siblings(".accordion-content[data-tab='" + accordionItem + "']").slideToggle();
                        });

                        if ($target.is('.refinement-bar button.reset')) {
                            $('.filtre-desktop .secondary-bar .reset').removeClass('d-block').addClass('d-none');
                        } else {
                            $('.filtre-desktop .secondary-bar .reset').removeClass('d-none').addClass('d-block');
                        }

                        if ($(window).width() < 840) {
                            var countChecked = $('.refinement-bar-block-desktop .check-square.checked').length;
                            if (countChecked > 0) {
                                $('.count-filter').append('(' + countChecked + ')');
                            }
                            var $clickedButton = $('.refinements-order-mobile .values button');
                            var selectedText = $clickedButton.find('span[aria-hidden="true"].selected').text().trim();
                            $('.refinement-trie .accordion-title h3 .title-trie-text').text(selectedText);
                            $('.filter-trie-block .order-selected').empty().text(selectedText);
                        }
                        var tecCountProduct = $('.grid-footer').data('page-count');
                        $(".results-count h2").text(function (i, txt) {
                            return txt.replace(/\d+/, tecCountProduct);
                        });
                        applyScrolling();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },
    applyFilterMobile: function () {
        var selectedFilters = {};
        
        // Capture les paramètres initiaux au chargement
        var initialParams = {};
        const urlParams = new URLSearchParams(window.location.search);
        for (const [key, value] of urlParams.entries()) {
            if (!initialParams[key]) {
                initialParams[key] = [];
            }
            initialParams[key].push(value);
        }
    
        $('.container').on(
            'click',
            '.filtre-mobile .refinements li button ,.filtre-mobile .filter-value button,.filtre-mobile .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
    
                var $button = $(this);
                $button.find('.check-square').toggleClass('checked');

                var parentRefinement = $('.filtre-mobile .check-square').parents('.refinement-bar');

                if ($('.filtre-mobile .check-square.checked').length > 0) {
                    parentRefinement.find('.result-count button').removeClass('disbaled-button');
                } else {
                    parentRefinement.find('.result-count button').addClass('disbaled-button');
                }
    
                var filterUrl = $button.data('href');
                
                if (filterUrl) {
                    var urlParams = new URLSearchParams(filterUrl.split('?')[1]);
    
                    for (const [key, value] of urlParams.entries()) {
                        if (!selectedFilters[key]) {
                            selectedFilters[key] = [];
                        }
    
                        // Ajouter ou retirer les valeurs dynamiques
                        if ($button.find('.check-square').hasClass('checked')) {
                            if (!selectedFilters[key].includes(value)) {
                                selectedFilters[key].push(value);
                            }
                        } else {
                            const index = selectedFilters[key].indexOf(value);
                            if (index > -1) {
                                selectedFilters[key].splice(index, 1);
                            }
                        }
                    }
    
                    if (!selectedFilters.baseUrl) {
                        selectedFilters.baseUrl = filterUrl.split('?')[0];
                    }
                }
            }
        );
    
        $('.container').on('click', '.refinemnt-footer .result-count button', function (e) {
            e.preventDefault();
    
            if (Object.keys(selectedFilters).length > 1) {
                $.spinner().start();
    
                var combinedParams = new URLSearchParams();
    
                // Ajouter les filtres dynamiques restants
                for (const key in selectedFilters) {
                    if (key !== 'baseUrl') {
                        selectedFilters[key].forEach(function (value) {
                            combinedParams.append(key, value);
                        });
                    }
                }
    
                var finalUrl = (selectedFilters.baseUrl || window.location.href.split('?')[0]) + '?' + combinedParams.toString();

                $.ajax({
                    url: finalUrl,
                    method: 'GET',
                    success: function (response) {
                        parseResultsMobile(response);
                        fixedRefinementBarMobile();
                        paginationPlp();
                        $.spinner().stop();
    
                        selectedFilters = {}; // Réinitialise uniquement les filtres dynamiques
                        $('.reset-mobile.reset').removeClass('d-none').addClass('d-block');
                        $('.reset-mobile-header.reset').on('click', function () {
                            $('.reset-mobile.reset').removeClass('d-block').addClass('d-none');
                        });
                        $('.reset-mobile.reset').on('click', function () {
                            $(this).removeClass('d-block').addClass('d-none');
                        });
    
                        if ($(window).width() < 840) {
                            var countChecked = $('.filtre-mobile .check-square.checked').length;
                            if (countChecked > 0) {
                                $('.count-filter').append('(' + countChecked + ')');
                            }
                            var $selectedOption = $('.refinements-order-mobile .values button .check-square.checked');
                            var $selectedButton = $selectedOption.parents('button');
                            var selectedText = $selectedButton.find('span[aria-hidden="true"]').text().trim();
                            if ($selectedButton.length > 0) {
                                $('.refinement-trie .accordion-title h3 .title-trie-text').text(selectedText);
                                $('.filter-trie-block .order-selected').empty().text(selectedText);
                            }
                        }
    
                        var tecCountProduct = $('.tec-product-tile').length;
                        $(".results-count h2").text(function (i, txt) {
                            return txt.replace(/\d+/, tecCountProduct);
                        });
    
                        applyScrolling();
                        $('.secondary-bar .reset').removeClass('d-none').addClass('d-block');
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });

        $('.container').on('click', '.refinement-bar .close-refinement', function (e) {
            e.preventDefault();
            var parentRefinement = $(this).parents('.refinement-bar');
            parentRefinement.find('.accordion-item .check-square').removeClass('checked');
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    }
};

$('.product-comparison').addClass('tec-search');

$(".tileVariationAttributes .size-plp").each(function () {
    var $block = $(this);
    var $items = $block.find("a");

    if ($items.length > 3) {
        $items.slice(0, 3).show();

        $items.slice(3).hide();

        var remainingCount = $items.length - 3;

        var $remainingSpan = $('<a class="restOfVariation-link"><span class="restOfVariation">+' + remainingCount + '</span></a>');

        $block.append($remainingSpan);
    }
});

$('.tec-badge span').each(function() {
    if ($(this).text().trim() !== '') {
        $(this).closest('.tec-badge').addClass('badge-exist');
    }
});

$(document).on('click', '.click-more-filtre', function() {
    $('.custom-scroll').mCustomScrollbar('scrollTo', 'bottom', {
        scrollInertia: 500 
    });
    $(this).hide();
});

var maxVisibleItems = 5;

$('.refinements .accordion-item').each(function () {
    var $list = $(this).find('.values.content');
    var $listItems = $list.find('li');
    var $seeMoreBtn = $listItems.siblings('.see-more-btn');

    if ($listItems.length > maxVisibleItems) {
        $listItems.slice(maxVisibleItems).hide();
        $seeMoreBtn.removeClass('d-none').addClass('d-block');
    }

    $seeMoreBtn.on('click', function () {
        $listItems.show();
        $(this).removeClass('d-block').addClass('d-none');
    });
});

function applyScrolling () {
    var viewSize = $(window).width();

    if(viewSize > 769) {
        var heightOfHeader = $('header').outerHeight();
        var heightbreadCrumb = $('.breadcrumb').outerHeight();
        var $firstChildBlock = $('.first-part-scrolling');
    
        $firstChildBlock.css('top',(heightOfHeader + heightbreadCrumb) + 'px');
    
        var $childBlock = $('.second-part-scrolling');
        var childHeight = $childBlock.outerHeight(true);
    }
}

var parentRefinement = $('.filtre-mobile .check-square').parents('.refinement-bar');

if ($('.filtre-mobile .check-square.checked').length > 0) {
    parentRefinement.find('.result-count button').removeClass('disbaled-button');
} else {
    parentRefinement.find('.result-count button').addClass('disbaled-button');
}

applyScrolling();


function fixedRefinementBarMobile() {
    const $header = $('.mobile-grid-header');
    const $tiles = $('.col-md-3.tec-search.tec-product-tile .product');
    const headerInitialOffset = $header.offset().top;
  
    let lastScrollTop = 0;
  
    function areAllTilesAboveViewport() {
      const windowTop = $(window).scrollTop();
  
      return $tiles.length > 0 && $tiles.toArray().every(tile => {
        const tileBottom = $(tile).offset().top + $(tile).outerHeight();
        return tileBottom <= windowTop;
      });
    }
  
    $(window).on('scroll', function () {
      const scrollTop = $(window).scrollTop();
  
      if (scrollTop > lastScrollTop) {
        // Scroll vers le bas
        if (areAllTilesAboveViewport()) {
          $header.addClass('hidden-header');
        } else if (scrollTop >= headerInitialOffset) {
          $header.addClass('fixed-header').removeClass('hidden-header');
        }
      } else {
        // Scroll vers le haut
        if (scrollTop <= headerInitialOffset) {
          $header.removeClass('fixed-header');
        } else {
          $header.addClass('fixed-header').removeClass('hidden-header');
        }
      }
  
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
  }
  

fixedRefinementBarMobile();

function paginationPlp() {
    const maxVisiblePages = 10;
    const $paginationItems = $('.pagination .page-item').not('.prev-page, .next-page');
    
    let currentPageIndex = $paginationItems.filter('.disabled').index() - 1;
    
    function updatePaginationDisplay() {
        $paginationItems.hide();
    
        let startPage = Math.max(0, currentPageIndex - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(startPage + maxVisiblePages, $paginationItems.length);
    
        if (endPage - startPage < maxVisiblePages) {
            startPage = Math.max(0, endPage - maxVisiblePages);
        }
    
        $paginationItems.slice(startPage, endPage).show();
    
        $paginationItems.removeClass('disabled');
    
        if (currentPageIndex >= 0 && currentPageIndex < $paginationItems.length) {
            $paginationItems.eq(currentPageIndex).addClass('disabled');
        }
    
        localStorage.setItem('currentPageIndex', currentPageIndex);
    }
    
    function handlePageChange(direction) {
        if (direction === 'next' && currentPageIndex + 1 < $paginationItems.length) {
            currentPageIndex++;
        } else if (direction === 'prev' && currentPageIndex > 0) {
            currentPageIndex--;
        }
        updatePaginationDisplay();
    }
    
    $('.pagination .prev-page a').on('click', function (e) {
        handlePageChange('prev');
    });
    
    $('.pagination .next-page a').on('click', function (e) {
        handlePageChange('next');
    });
    
    updatePaginationDisplay();
}

paginationPlp();

var $selectedOption = $('.order-desktop .refinements-order:not(.refinements-order-mobile) .values button .check-square.checked');
var $selectedButton = $selectedOption.parents('button');

if ($selectedButton.length > 0) {
    var selectedText = $selectedButton.find('span[aria-hidden="true"]').text().trim();
    $('.refinement-trie .accordion-title h3 .title-trie-text').empty().text(selectedText);
    $('.filter-trie-block .order-selected').empty().text(selectedText);

    function syncCheckedState() {

        $('.refinements-order:not(.refinements-order-mobile) .values button').each(function() {
            var selectedText = $(this).find('span[aria-hidden="true"]').text().trim();
            var isChecked = $(this).find('i').hasClass('checked');

            $('.refinements-order-mobile .values button').each(function() {
                var buttonTextSelected = $(this).find('span[aria-hidden="true"]');
                var buttonText = $(this).find('span[aria-hidden="true"]').text().trim();
                if (buttonText === selectedText) {
                    if (isChecked) {
                        $(this).find('i').addClass('checked');
                        buttonTextSelected.addClass('selected');
                    } else {
                        $(this).find('i').removeClass('checked');
                        buttonTextSelected.removeClass('selected');
                    }
                }
            });
        });
    }

    syncCheckedState();
}




